import cloneDeep from 'lodash/cloneDeep';
import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';

import api from 'app/resources/terms-management.api';
import { clearCmsTerms } from 'app/actions/terms-management.actions';

import template from './terms-tab.html';

const mapStateToThis = (state) => {
  const { termsManagement, session, ui, config } = state;

  const { locale } = session;
  const { selectedLanguage } = ui;
  const { fields, attachments, title: moduleName } = termsManagement;
  const { locales } = config;

  return {
    fields,
    attachments,
    locale,
    selectedLanguage,
    locales,
    moduleName,
  };
};

const mapDispatchToThis = {
  clearCmsTerms,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$sce', 'Notifications', 'gettextCatalog')
class TermsTabController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.editMode = false;
    this.DIRTY_FORM = this.type;
    this.termsType = this.type;
    this.termsModuleName = 'terms and conditions';

    await this.action();

    this.clone();
    this.setEntries(this.locale);
  }

  $onDestroy() {
    this.clearCmsTerms();
    this.unsubscribe();
  }

  setEntries(locale) {
    const findLocaleKey = (key) => key === locale;
    const fieldsKey = Object.keys(this.copyFields).find(findLocaleKey);
    const attachmentsKey = Object.keys(this.copyAttachments).find(findLocaleKey);

    if (!fieldsKey) {
      this.copyFields[locale] = [{ id: 'html' }];
    }

    if (!attachmentsKey) {
      this.copyAttachments[locale] = {};
    }
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  clone() {
    this.copyFields = this.fields ? cloneDeep(this.fields) : {};
    this.copyAttachments = this.attachments ? cloneDeep(this.attachments) : {};
  }

  cancel() {
    this.toggleEditMode();
    this.clone();
  }

  preview() {
    const content = this.$sce.trustAsHtml(this.copyFields[this.selectedLanguage][0].value);

    this.Notifications.showComplexDialog({
      component: 'termsPreviewDialog',
      resolve: {
        content: () => content,
        title: () => this.title,
      },
    });
  }

  chekIfAttachmentEmpty() {
    this.locales.forEach(({ code }) => {
      if (this.copyAttachments) {
        this.copyAttachments[code] = isEmpty(this.copyAttachments[code]) ? undefined : this.copyAttachments[code];
      }
    });
  }

  // eslint-disable-next-line consistent-return
  save(form) {
    this.chekIfAttachmentEmpty();

    const payload = {
      title: this.moduleName,
      fields: this.copyFields,
      attachments: this.copyAttachments,
      termsType: this.termsType,
    };

    form.$setSubmitted();

    if (form.$valid) {
      if (this.moduleName === this.termsModuleName) {
        return this.showConfirmationDilog().then(() => {
          this.onSave(payload);
          form.$setPristine();
        });
      }

      return this.onSave(payload).then(() => {
        form.$setPristine();
      });
    }
  }

  downloadAttachment() {
    const [attachment] = this.attachments[this.locale];
    const { id: contentId, name } = attachment;

    return api.downloadTerms(contentId, name);
  }

  showConfirmationDilog() {
    return this.Notifications.showComplexDialog({
      component: 'termsConfirmDialog',
    }).result;
  }

  onSave(payload) {
    return api.saveTerms(payload).then(() => {
      this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been published'));
      this.toggleEditMode();
    });
  }
}

export default class TermsTabComponent {
  constructor() {
    this.controller = TermsTabController;
    this.template = template;
    this.bindings = {
      action: '&',
      title: '@',
      type: '@',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-tab/terms-tab-component.js